class UserActivityLogService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  get(params) {
    return this.apiService.get('/api/v1/avg/user-activity-log', params);
  }
}

export default UserActivityLogService;
